import { ObstetricalFileFormResources } from "../../Resources/ObstetricalFileFormResources";
import { BritishColumbiaResourcesDiscussionTopics } from "./BritishColumbiaResourcesDiscussionTopics";

class BritishColumbiaObstetricalFileFormResources extends ObstetricalFileFormResources {
    public DiscussionTopics: BritishColumbiaResourcesDiscussionTopics;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileFormResources>) {
        super(fields);
        this.DiscussionTopics = new BritishColumbiaResourcesDiscussionTopics(fields?.DiscussionTopics);
    }

    public get anxietySubScorePostnatalDepressionScore(): number {
        if (this.PostnatalDepressionScale.SelfBlameScore == null
            && this.PostnatalDepressionScale.AnxietyScore == null
            && this.PostnatalDepressionScale.PanicScore == null
        )
            return null;

        return (this.PostnatalDepressionScale.SelfBlameScore ?? 0)
            + (this.PostnatalDepressionScale.PanicScore ?? 0)
            + (this.PostnatalDepressionScale.AnxietyScore ?? 0);
    }
}

export { BritishColumbiaObstetricalFileFormResources };
